const allLinks = document.querySelectorAll('a');

interface Offset {
  left: number;
  top: number;
}

function getOffset(el: HTMLElement): Offset {
  let x = 0;
  let y = 0;
  while (el && !Number.isNaN(el.offsetLeft) && !Number.isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop; // @ts-ignore
    el = el.offsetParent;
  }
  return { top: y, left: x };
}

function hashNavigation(target) {
  const targetHash = target.hash.substr(1);
  const targetEle = <HTMLElement>document.getElementById(targetHash);

  if (targetEle) {
    const targetTop = getOffset(targetEle).top;
    window.scrollTo({
      top: targetTop,
      left: 0,
      behavior: 'smooth',
    });
  }
}

allLinks.forEach((link: HTMLAnchorElement) => {
  if (link.href.includes('#') && !link.hasAttribute('data-ss-ss-link')) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      hashNavigation(link);
    });
  }
});

allLinks.forEach((link: HTMLAnchorElement) => {
  if (link.hasAttribute('data-ss-ss-link')) {
    link.href = link.getAttribute('data-ss-ss-link');
    link.target = '_blank';
  }
});
